import { Component, ViewChild, TemplateRef } from '@angular/core';

@Component({
	selector: 'app-page-edit-title',
	templateUrl: 'page-edit-title.component.html',
	styleUrls: ['page-edit-title.component.scss']
})
export class PageEditTitleComponent {
	@ViewChild(TemplateRef, { static: true })
	template: TemplateRef<any>;
}
